// 无bdo银行卡跳转页面
<template>
    <div class="bodNoAccount">
        <div class="img"><img src="@/assets/pc/img_no_bdo.png" /></div>
        <div class="describe">
            <p>You'll need a BDO Savings Account or a BDO Network Bank Deposit Account for the settlement of customer payments via BDO Checkout. </p>
            <p>Opening an account is easy! You may open a BDO Savings Account online at 
                <a target="_blank" rel="noopener" href="https://www.bdo.com.ph/personal/digitalbanking/savings-account-opening">bdo.com.ph/online-account-opening</a>.
                You may also open a BDO Network Bank Deposit Account at the nearest BDO Network Bank branch. 
            </p>
            <p>In the meantime, you may proceed with your application.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "BdoNoAccount",
    data() {
        return{}
    },
    methods: {}
}
</script>
<style lang="scss" scoped>
.bodNoAccount{
    overflow: hidden;
    margin-bottom: 4px;
    & > div {
        float: left;
    }
    .img {
        width: 320px;
        margin-right: 50px;
        img {
            width: 100%;
        }
    }
    .describe {
        width: 363px;
        p {
            font: normal normal normal 16px/24px Nunito;
            margin-bottom: 24px;
        }
        a {
            color: #0072D8;
            text-decoration: underline;
        }
    }
}
</style>